
  /**
   * @license
   * author: epignosis front-end team
   * @epignosis_llc/gnosis.js v6.0.0
   * Released under the MIT license.
   */

import { objectWithoutProperties as _objectWithoutProperties, extends as _extends } from '../../../_virtual/_rollupPluginBabelHelpers.js';
import 'react';
import classNames from '../../../node_modules/classnames/index.js';
import { statusTagStyles } from './styles.js';
import { createElement as jsx } from '../../../node_modules/@emotion/react/dist/emotion-react.browser.esm.js';

var _excluded = ["testId", "text", "icon", "size", "color", "ariaLabel", "fontWeight"];
var StatusTag = function StatusTag(_ref) {
  var testId = _ref.testId,
    text = _ref.text,
    Icon = _ref.icon,
    _ref$size = _ref.size,
    size = _ref$size === void 0 ? "md" : _ref$size,
    _ref$color = _ref.color,
    color = _ref$color === void 0 ? "neutral" : _ref$color,
    ariaLabel = _ref.ariaLabel,
    fontWeight = _ref.fontWeight,
    rest = _objectWithoutProperties(_ref, _excluded);
  var dataTestId = testId ? testId : "status-tag-".concat(text);
  var defaultFontWeight = size === "sm" ? "700" : "400";
  return jsx("span", _extends({
    css: function css(theme) {
      return statusTagStyles(theme, {
        size: size,
        fontWeight: fontWeight !== null && fontWeight !== void 0 ? fontWeight : defaultFontWeight
      });
    },
    "data-testid": dataTestId,
    className: classNames("statusTag", "statusTag--".concat(size), "statusTag--".concat(color)),
    role: "status",
    "aria-label": ariaLabel !== null && ariaLabel !== void 0 ? ariaLabel : text
  }, rest), Icon && jsx("span", {
    className: "statusTag__icon",
    "aria-hidden": "true"
  }, jsx(Icon, {
    height: 16
  })), text && jsx("span", {
    className: "statusTag__text"
  }, text));
};

export { StatusTag as default };
//# sourceMappingURL=StatusTag.js.map
